// Shared, memoized pdf.js loader. pdf.js + its worker is loaded once and
// reused across every client-side feature that rasterizes a PDF page:
//   - docThumbnail.ts  — first-page thumbnail for the upload tiles
//   - detectBarcode.ts — first-page raster scanned for a barcode
//
// GlobalWorkerOptions.workerSrc is a module-level singleton, so it must be
// set exactly once. Centralizing the loader here keeps both callers from
// racing to import pdf.js and re-assign the worker. Lazy: nothing is pulled
// until the first PDF is actually in hand (the worker URL is resolved by
// Vite's ?url into a hashed asset in the build), so customers who never
// upload a PDF never download pdf.js.

let pdfjsPromise: Promise<typeof import('pdfjs-dist')> | null = null;

export function loadPdfjs(): Promise<typeof import('pdfjs-dist')> {
  if (!pdfjsPromise) {
    pdfjsPromise = (async () => {
      const pdfjs = await import('pdfjs-dist');
      const workerSrc = (await import('pdfjs-dist/build/pdf.worker.min.mjs?url')).default;
      pdfjs.GlobalWorkerOptions.workerSrc = workerSrc;
      return pdfjs;
    })();
  }
  return pdfjsPromise;
}
